const STORAGE_PREFIX = 'ghostflow-ticket-read:'

/**
 * Mark a ticket as "read" by storing the current client timestamp.
 * Uses client time (always after server's updatedAt) to avoid
 * format mismatches between different backend endpoints.
 */
export function markTicketRead(ticketId: string): void {
  try {
    localStorage.setItem(`${STORAGE_PREFIX}${ticketId}`, new Date().toISOString())
    // Notify hooks so badge count recalculates immediately
    window.dispatchEvent(new CustomEvent('ghostflow-ticket-read'))
  } catch {
    // localStorage may be unavailable — ignore
  }
}

/**
 * Check if a ticket has unread activity from the other party.
 * Returns true if the ticket was updated after the last time the user read it
 * AND the last message was sent by the specified sender type.
 */
export function isTicketUnread(
  ticketId: string,
  updatedAt: string,
  lastSenderType: string | undefined,
  incomingSenderType: string,
): boolean {
  if (lastSenderType !== incomingSenderType) return false
  try {
    const lastRead = localStorage.getItem(`${STORAGE_PREFIX}${ticketId}`)
    if (!lastRead) return true // never viewed = unread
    return updatedAt > lastRead
  } catch {
    return false
  }
}
